import '../scss/main.scss'
import {Application} from "@hotwired/stimulus"
import {definitionsFromContext} from "@hotwired/stimulus-webpack-helpers"
import 'bootstrap';
import AOS from 'aos';

const application = Application.start()
const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context))

AOS.init({
    disable: 'phone',
    once: true,
    duration: 800
});

// Correction du problème du scroll horizontale généré par data-aos
if (document.querySelectorAll('[data-aos="fade-right"]'))
{
    document.querySelectorAll('[data-aos="fade-right"]').forEach((node) => {
        node.parentElement.classList.add('overflow-x-hidden');
    });

    const scrollFadeIn = () => {
        document.querySelectorAll('[data-aos="fade-right"]').forEach((node) => {
            const distInView = node.getBoundingClientRect().top - window.innerHeight;
            if (distInView < 0)
            {
                if (node.classList.contains('aos-animate') && node.parentElement.classList.contains('overflow-x-hidden'))
                {
                    node.parentElement.classList.remove('overflow-x-hidden');
                }
            }
            else
            {
                node.parentElement.classList.add('overflow-x-hidden');
            }
        });
    }

    window.addEventListener('scroll', scrollFadeIn);
}

if (document.querySelectorAll('.contain-sommaire-ml'))
{
    document.querySelectorAll('.contain-sommaire-ml').forEach((container) => {
        let anchors = container.querySelectorAll('a');
        if (anchors)
        {
            let tiret = document.createElement('div');
            tiret.classList.add('divider-tiret');
            tiret.innerText = '-';
            anchors.forEach((anchor, index) => {
                if (index > 0)
                {
                    let tiretClone = tiret.cloneNode(true);
                    container.insertBefore(tiretClone, anchor);
                }
            })
        }
    })
}

if (document.querySelectorAll('a[href^="#"]'))
{
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.addEventListener('click', (event) => {
            event.preventDefault();
            let target = document.querySelector('#' + event.target.getAttribute('href').substring(1));
            if (target)
            {
                let targetPositionWithHeader = (target.getBoundingClientRect().top + window.scrollY) - 160;
                window.scrollTo({
                    behavior: 'auto',
                    top: targetPositionWithHeader
                });
                history.pushState({}, '', event.target.getAttribute('href'));
            }
        })
    })
}